export enum Categories {
  college,
  licences,
  plugins,
  messaging,
  classDefaults,
  ldap,
  maintenance,
  avetmiss,
  fundingContracts,
  financial,
  holidays,
  paymentTypes,
  taxTypes,
  concessionTypes,
  contactRelationTypes,
  customFields,
  dataCollectionForms,
  security,
  product,
  contact,
  courseTypes,
  classTypes
}
